module.exports = __webpack_public_path__ + "img/gnb.c1e88a91.svg";